/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_u15m_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`At an average reading speed of around 200-250 words per minute, 15 minutes covers roughly 3,000-3,750 words, or about 10-15 pages of a typical novel. That's enough to make steady progress through a book in daily short sessions.`)
};

const es_timer_u15m_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A una velocidad de lectura promedio de unas 200-250 palabras por minuto, 15 minutos cubren aproximadamente 3.000-3.750 palabras, o unas 10-15 páginas de una novela típica. Eso es suficiente para avanzar de forma constante en un libro con sesiones diarias cortas.`)
};

const de_timer_u15m_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bei einer durchschnittlichen Lesegeschwindigkeit von etwa 200–250 Wörtern pro Minute decken 15 Minuten rund 3.000–3.750 Wörter ab, also etwa 10–15 Seiten eines typischen Romans. Das reicht für stetigen Fortschritt in einem Buch über tägliche kurze Sessions.`)
};

const nl_timer_u15m_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bij een gemiddelde leessnelheid van ongeveer 200-250 woorden per minuut dekken 15 minuten ruwweg 3.000-3.750 woorden, oftewel ongeveer 10-15 pagina's van een gemiddelde roman. Dat is genoeg om gestaag vooruitgang te boeken in een boek met dagelijkse korte sessies.`)
};

const fr_timer_u15m_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avec une vitesse de lecture moyenne d’environ 200 à 250 mots par minute, 15 minutes couvrent environ 3 000 à 3 750 mots, soit environ 10 à 15 pages d’un roman classique. C’est suffisant pour progresser régulièrement dans un livre grâce à de courtes sessions quotidiennes.`)
};

const it_timer_u15m_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A una velocità di lettura media di circa 200-250 parole al minuto, 15 minuti coprono circa 3.000-3.750 parole, ovvero circa 10-15 pagine di un romanzo tipico. È abbastanza per fare progressi costanti in un libro con brevi sessioni giornaliere.`)
};

const pt_br2_timer_u15m_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Com uma velocidade média de leitura de cerca de 200-250 palavras por minuto, 15 minutos cobrem aproximadamente 3.000-3.750 palavras, ou cerca de 10-15 páginas de um romance comum. Isso é suficiente para avançar de forma constante em um livro com sessões curtas diárias.`)
};

const pt_timer_u15m_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A uma velocidade de leitura média de cerca de 200-250 palavras por minuto, 15 minutos cobrem aproximadamente 3.000-3.750 palavras, ou cerca de 10-15 páginas de um romance típico. Isso é suficiente para progredir de forma constante num livro em sessões curtas diárias.`)
};

const ja_timer_u15m_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`平均的な読書速度である1分あたり約200〜250語で計算すると、15分でおよそ3,000〜3,750語、一般的な小説の10〜15ページ程度をカバーできます。毎日の短いセッションで本を着実に読み進めるには十分な量です。`)
};

const zh_timer_u15m_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`以每分钟约200-250词的平均阅读速度计算，15分钟大约能读3,000-3,750词，相当于一本普通小说的10-15页。这足以让你通过每天的短时阅读稳步读完一本书。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_u15m_faq4_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_u15m_faq4_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_u15m_faq4_a", locale)
	if (locale === "en") return en_timer_u15m_faq4_a(inputs)
	if (locale === "es") return es_timer_u15m_faq4_a(inputs)
	if (locale === "de") return de_timer_u15m_faq4_a(inputs)
	if (locale === "nl") return nl_timer_u15m_faq4_a(inputs)
	if (locale === "fr") return fr_timer_u15m_faq4_a(inputs)
	if (locale === "it") return it_timer_u15m_faq4_a(inputs)
	if (locale === "pt-BR") return pt_br2_timer_u15m_faq4_a(inputs)
	if (locale === "pt") return pt_timer_u15m_faq4_a(inputs)
	if (locale === "ja") return ja_timer_u15m_faq4_a(inputs)
	return zh_timer_u15m_faq4_a(inputs)
};